module.exports = __webpack_public_path__ + "media/images/icons/twotone/tablet-fbe73aa3e9fd9b857646c6fa5b1a7e33.svg";